import { useState, useEffect } from 'react';

export interface BreakpointValues {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  screenWidth: number;
}

const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
};

export const useResponsive = (): BreakpointValues => {
  const [screenWidth, setScreenWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      console.log('Screen width changed:', newWidth);
      setScreenWidth(newWidth);
    };

    // Verificar el tamaño inicial
    console.log('Initial screen width:', window.innerWidth);
    setScreenWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenWidth < BREAKPOINTS.mobile;
  const isTablet = screenWidth >= BREAKPOINTS.mobile && screenWidth < BREAKPOINTS.tablet;
  const isDesktop = screenWidth >= BREAKPOINTS.tablet;

  console.log('useResponsive:', { isMobile, isTablet, isDesktop, screenWidth });

  return {
    isMobile,
    isTablet,
    isDesktop,
    screenWidth,
  };
};

export default useResponsive;
